import { Link } from "@mui/material";
import { ReactNode } from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";

import SidebarItem from "./SidebarItem";

interface SidebarNavProps {
  icon: ReactNode;
  label: string;
  link: string;
  expanded: boolean;
}

const SidebarNav = ({ icon, label, link, expanded }: SidebarNavProps) => {
  const { pathname } = useLocation();
  const isRootPath = link === "/community";
  const active = isRootPath ? pathname === link : pathname.startsWith(link);

  return (
    <Link
      sx={{ color: "inherit", textDecoration: "none" }}
      to={link}
      component={RouterLink}
    >
      <SidebarItem
        icon={icon}
        label={label}
        expanded={expanded}
        active={active}
      />
    </Link>
  );
};

export default SidebarNav;
